module.exports = __webpack_public_path__ + "img/en_en.99c26353.png";